var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list',{attrs:{"label":_vm.$t('jobs'),"refresh":this.refresh,"table":"scraper","hideNewAndEdit":true,"initialSortBy":"starttimescraper","initialSortDesc":true},on:{"childMessage":_vm.onMessageFromListReceived}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }